import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import ClassNames from "classnames";
import _ from "lodash";

import Client from "shopify-buy";
import Discount from "../utils/discount";
import Header from "../buy/header";
import Intro from "../buy/intro";
import Reviews from "../buy/reviews";
import Selector from "../buy/selector";
import Purchase from "../buy/purchase";
import LessStress from "../buy/less-stress";
import Supercharge from "../home/supercharge-cta";

import PURCHASE_OPTIONS from "../buy/purchase-options";
let DISCOUNT = new Discount();

const client = Client.buildClient({
  domain: "store.drinkyogaflow.com",
  storefrontAccessToken: "50ad06d768e2ba0eadfce5bda1608413"
});

import Bus from "../utils/bus";
import Ingredients from "../buy/ingredients";
import NutritionalModal from "../components/page/nutritional-modal";
import ProductBadges from "../buy/badges";
import HighlightedReviews from "../buy/highlighted-reviews";
let BUS = new Bus();

class BuyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVariantIndex: 1,
      selectedPurchaseOption: PURCHASE_OPTIONS.ONE_TIME,
      instructor: ""
    };
    this.changeSelection = this.changeSelection.bind(this);
    this.purchaseProduct = this.purchaseProduct.bind(this);
    this.applyPromoCode = this.applyPromoCode.bind(this);
    this.changePurchaseType = this.changePurchaseType.bind(this);
    this.openFreeShippingInfo = this.openFreeShippingInfo.bind(this);
    this.openRefundPolicyInfo = this.openRefundPolicyInfo.bind(this);
    this.openDeliveryInfo = this.openDeliveryInfo.bind(this);
    this.handlePurchase = this.handlePurchase.bind(this);
  }

  componentDidMount() {
    if (client) {
      client.checkout.create().then(checkout => {
        this.setState({
          checkout: checkout
        });
      });
    }
    var _learnq = _learnq || [];
    let product = this.props.data.product;
    var item = {
      Name: product.title,
      ProductID: product.id,
      ImageURL: product.images[0].originalSrc,
      URL: "https://www.drinkyogaflow.com/",
      Brand: "Weekday Warriors",
      Price: product.price
    };
    _learnq.push(["track", "Viewed Product", item]);
    _learnq.push([
      "trackViewedItem",
      {
        Title: item.Name,
        ItemId: item.ProductID,
        Categories: item.Categories,
        ImageUrl: item.ImageURL,
        Url: item.URL,
        Metadata: {
          Brand: item.Brand,
          Price: item.Price
        }
      }
    ]);

    // FB Pixel event
    if (typeof window !== "undefined") {
      if (window.fbq != null) {
        window.fbq('track', 'ViewContent')
      }
    }
  }

  applyPromoCode(code) {
    this.setState({
      instructor: code
    });
  }

  handlePurchase() {
    let product = this.props.data.product;
    let variant = product.variants[this.state.selectedVariantIndex];
    switch (this.state.selectedPurchaseOption) {
      case PURCHASE_OPTIONS.ONE_TIME:
        this.purchaseProduct(variant.shopifyId);
        break;
      case PURCHASE_OPTIONS.SUBSCRIPTION:
        product = this.props.data.subscription;
        let return_url = `${window.location.origin}/purchase-subscription`;
        let url = `https://store.drinkyogaflow.com/products/${
          product.handle
        }?variant_index=${
          this.state.selectedVariantIndex
        }&return_url=${encodeURI(return_url)}&to_sub=true&instructor=${
          this.state.instructor
        }`;
        window.location.href = url;
        break;
      default:
        return;
    }
  }

  changePurchaseType(type) {
    this.setState({
      selectedPurchaseOption: type
    });
  }

  learnMore(event) {
    event.preventDefault();
    BUS.trigger("show-text-modal", {
      html: this.props.data.collection.descriptionHtml
    });
  }

  purchaseProduct(variantId) {
    if (this.state.checkout) {
      const checkoutId = this.state.checkout.id;
      const lineItemsToAdd = [
        {
          variantId,
          quantity: 1
        }
      ];

      let note = "Instructor not specified";
      if (this.state.instructor !== "") {
        note = `Instructor: ${this.state.instructor}`;
      }

      client.checkout
        .create({
          lineItems: lineItemsToAdd,
          note: note
        })
        .then(checkout => {
          this.setState({
            checkout: checkout,
            canInteract: true
          });
          let webUrl = checkout.webUrl;
          if(window.ga && ga.create) {
            var client_id = ga.getAll()[0].get('linkerParam');
            if (client_id.length > 0) {
              webUrl += '&' + client_id;
            }
          }
          window.location.href = webUrl;
        })
        .catch(error => {
          console.log("addToCart error", error);
        });
    }
  }

  openFreeShippingInfo() {
    let data = this.props.data;

    BUS.trigger("show-text-modal", {
      html: data.freeShippingInfo.content
    });
  }

  openRefundPolicyInfo() {
    let data = this.props.data;

    BUS.trigger("show-text-modal", {
      html: data.refundPolicyInfo.content
    });
  }

  openNutritionalInfo() {
    BUS.trigger("OPEN_NUTRITIONAL");
  }

  openDeliveryInfo() {
    BUS.trigger("show-text-modal", {
      html: this.props.data.deliveryInfo.content
    });
  }

  changeSelection(i) {
    this.setState({
      selectedVariantIndex: i
    });
  }

  render() {
    let data = this.props.data;
    let domain = "https://www.drinkyogaflow.com";
    let sku = "749353336876";
    let url = "https://www.drinkyogaflow.com";
    let homepage = this.props.data.homepage.edges[0].node;
    let ingredients = this.props.data.ingredients.edges;

    return (
      <div className="Buy">
        <Selector
          product={data.product}
          onSelectVariant={this.changeSelection}
          handleFreeShippingInfo={this.openFreeShippingInfo}
          handleRefundPolicyInfo={this.openRefundPolicyInfo}
          handleNutritionalInfo={this.openNutritionalInfo}
        />
        <Purchase
          update={this.changePurchaseType}
          options={PURCHASE_OPTIONS}
          product={data.product}
          subscription={data.subscription}
          selected={this.state.selectedPurchaseOption}
          selectedVariantIndex={this.state.selectedVariantIndex}
          variant={data.product.variants[this.state.selectedVariantIndex]}
          handleMoreInfo={this.openDeliveryInfo}
        />
        <div className="btn-container">
          <button onClick={this.handlePurchase} className="Btn btn-lg orange-white">
            Buy now
          </button>
          <div className="guarantee-text">100% NO-RISK MONEY BACK GUARANTEE</div>
          <img className="secure-payment-logos" src="/images/buy/safe-checkout-logos.png" alt="Secure Checkout" />
        </div>
        <ProductBadges />
        <Reviews url={url} sku={sku} product={data.product} />
        <NutritionalModal data={homepage.nutritionalInfo} />
      </div>
    );
  }
}

export default BuyPage;

BuyPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object.isRequired,
    product: PropTypes.object.isRequired
  }).isRequired
};

/* eslint no-undef: "off" */
export const query = graphql`
  query BuyPageProduct {
    homepage: allDatoCmsHomepage {
      edges {
        node {
          intro
          buyIntro
          introCallToAction
          buyCallToAction
          press {
            ... on DatoCmsLogo {
              url
              image {
                url
              }
              pressQuote
            }
          }
          solvingTheProblem
          superchargeTitle
          findYourPlaceTitle
          findYourPlaceBenefits {
            ... on DatoCmsFypBenefit {
              benefit
            }
          }
          nutritionalInfo {
            fluid {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
          }
          brookesStoryTitle
          brookesStoryCopy
          brookesStoryVideo {
            url
            title
            width
            height
            provider
            providerUid
            thumbnailUrl
          }
          brookesStoryImage {
            url
          }
          faqBlock {
            ... on DatoCmsBlock {
              question
              answer
            }
          }
          ourSocialPurpose
          ospTitle
          callToAction
          callToActionLink
        }
      }
    }
    ingredients: allDatoCmsIngredient(sort: { fields: [position], order: ASC }) {
      edges {
        node {
          name
          subName
          description
          shortDescription
          image {
            fluid(
              maxWidth: 450
              imgixParams: { fm: "jpg", auto: "compress" }
            ) {
              aspectRatio
              src
              srcSet
              sizes
            }
          }
          origin
          descriptionExtended
        }
      }
    }
    freeShippingInfo: datoCmsFreeShippingInfo {
      content
    }
    refundPolicyInfo: datoCmsRefundPolicyInfo {
      content
    }
    deliveryInfo: datoCmsDeliveryInfo {
      content
    }
    product: shopifyProduct(
      shopifyId: { eq: "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzE1MzM1OTA2MzQ1NDA=" }
    ) {
      handle
      id
      shopifyId
      title
      description
      descriptionHtml
      images {
        id
        originalSrc
        localFile {
          id
        }
      }
      variants {
        title
        shopifyId
        price
        image {
          id
        }
      }
    }
    subscription: shopifyProduct(
      shopifyId: { eq: "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzE3NTQ2ODcwNzg0NDQ=" }
    ) {
      handle
      id
      shopifyId
      title
      description
      descriptionHtml
      images {
        id
        originalSrc
        localFile {
          id
        }
      }
      variants {
        title
        shopifyId
        price
        image {
          id
        }
      }
    }
    collection: shopifyCollection(
      shopifyId: { eq: "Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzUxNDMwNzg1MDY4" }
    ) {
      title
      shopifyId
      descriptionHtml
      products {
        title
        shopifyId
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/buy.js